import React from 'react';
import '../../App.css';
import Carousel from './Carousel';
import BodyCard from './BodyCard';
import ContactForm from './ContactForm'
import Video from "./Video"


function Home() {
  return (
  <div>
    <Carousel/>
    <BodyCard/>
    <Video />
    <ContactForm />
    
  </div>
  );
}

export default Home;